import { emphasize } from '@material-ui/core/styles';

export default (theme) => ({
  root: {
    flexGrow: 1,
    // height: 250,
    // minWidth: 290,
    width: '100%',
    position: 'relative'
  },
  input: {
    verticalAlign: 'center',
    paddingTop: 6,
    paddingBottom: 15,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
    paddingBottom: 10,
  },
  chip: {
    margin: theme.spacing(0.5, 0.25),
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light'
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
      0.08
    ),
  },
  noOptionsMessage: {
    padding: theme.spacing(1, 2),
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    zIndex: 100,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing(2),
  },
  menuTitle: {
    fontSize: 16,
  },
  suggestionModal: {
    position: 'absolute',
    maxWidth: '50vw',
    width: 600,
    zIndex: 100,
    maxHeight: 300,
    overflow: 'auto',
  },
  suggestionTopModal: {
    position: 'absolute',
    maxWidth: '50vw',
    width: 600,
    zIndex: 100,
    maxHeight: 300,
    overflow: 'auto',
    bottom: 50
  }
});
